import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setCredentials, logOut } from './b24Slice';

const baseQuery = fetchBaseQuery({
    baseUrl: '/b24',
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
        const token = getState().b24.token;
        if (token) {
            headers.set("authorization", `Bearer ${token}`);
        }
        return headers;
    }
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api,extraOptions);

    if (result?.error?.status === 401) {

        const refreshResult = await baseQuery('/b24/refresh', api, extraOptions);
        if (refreshResult?.data) {
            const user = api.getState().b24.user;
            api.dispatch(setCredentials({ ...refreshResult.data, user }))

            result = await baseQuery(args, api, extraOptions);
        } else {
            api.dispatch(logOut());
        }
    }

    return result;
};

export const b24apiSlice = createApi({
    reducerPath: 'b24api', // optional
    baseQuery: baseQueryWithReauth,
    endpoints: builder => ({})
});